<template>
  <!--  <div>-->
  <!--    <h3>{{project.name}}</h3>-->
  <!--  </div>-->

  <v-card class="mx-auto" max-width="400">
    <v-img v-bind:src="bannerImageUrl" class="white--text" height="200px">
      <v-card-title class="align-end fill-height">{{ poiName }}</v-card-title>
    </v-img>

    <v-card-text>
      <span class="text--primary">
        <span v-html="descriptionText"></span>
      </span>
    </v-card-text>

    <v-card-actions>
      <v-btn text color="orange" @click="poiClick(poi.id)">Explore</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    poi: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    getMediaContent: function(poi) {
      for (var i = 0, len = poi.Media.length; i < len; i++) {
        var m = poi.Media[i]
        switch (m.mediaTypeId) {
          case 1: //poi name and description
            this.poiName = m.name
            this.descriptionText = m.textualContent.replace(
              /(\\r)*\\n/g,
              '<br>'
            )
            break
          case 2: //poi image
            this.bannerImageUrl =
              m.url + '?random=' + Math.floor(Math.random() * 10 + 1) //random part at the end gets random image each time from Picsum
            break
          case 10: //poi unity component data
            break
        }
      }
    },
    poiClick: function(id) {
      console.log('PoiCard.poiClick', id)
      //this.$router.push('/projects/'+projectId)
    }
  },
  data: function() {
    return {
      poiName: 'poi_name_placeholder',
      bannerImageUrl: 'img_url_placeholder',
      descriptionText: 'description placeholder'
    }
  },
  created: function() {
    this.getMediaContent(this.$props.poi)
  }
}
</script>

<style scoped></style>
